import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/node';
import comment from '../../snippets/comment';
import {locales} from '../sampleLocations';
import {CreateShellCommand} from '../../../components/left-col';

const createIntent = (country, reader) => {
  if (reader === 'wpe') {
    const currency = locales[country].currency;
    const pmTypes =
      country === 'CA'
        ? `['card_present', 'interac_present']`
        : `['card_present']`;
    return `
{+create-intent}
app.post("/create_payment_intent", async(req, res) => {
  // For Terminal payments, the 'payment_method_types' parameter must include
  // 'card_present' and the 'capture_method' must be set to 'manual'
  const {span response create-intent}intent{/span} = await stripe.paymentIntents.create({
    amount: req.body.amount,
    currency: '${currency}',
    payment_method_types: ${pmTypes},
    capture_method: 'manual',
  });
  res.json({client_secret: intent.client_secret});
})
{/create-intent}
`;
  }
};

const createLocation = (country) => {
  const location = locales[country].location;
  const city = location.address.city
    ? `
      city: '${location.address.city}',`
    : '';
  const state = location.address.state
    ? `
      state: '${location.address.state}',`
    : '';
  return `
const createLocation = async () => {
  {+create-location}
  const location = await stripe.terminal.locations.create({
    display_name: '${location.displayName}',
    address: {
      line1: '${location.address.line1}',${city}${state}
      country: '${location.address.country}',
      postal_code: '${location.address.postalCode}',
    }
  });
  {/create-location}

  return location;
};
`;
};

export const steps = {
  setup,
  'create-location': {},
  'connection-token-endpoint': {},
  'create-intent': {},
  'capture-intent-endpoint': {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.server.node.run-server.body',
        defaultMessage: 'Run your Node server and go to <a>localhost:4242</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant, reader, country}) => {
  return `const express = require("express");
const app = express();
const { resolve } = require("path");
{+setup}
${comment && comment(merchant)}
const stripe = require("stripe")("${keys.secret}");
{/setup}

app.use(express.static("public"));
app.use(express.json());
app.use(express.urlencoded({ extended: true }));
${createLocation(country)}
// The ConnectionToken's secret lets you connect to any Stripe Terminal reader
// and take payments with your Stripe account.
// Be sure to authenticate the endpoint for creating connection tokens.
{+connection-token-endpoint}
app.post("/connection_token", async(req, res) => {
  let {span response connection-token-endpoint}connectionToken{/span} = await stripe.terminal.connectionTokens.create();
  res.json({secret: connectionToken.secret});
})
{/connection-token-endpoint}
${createIntent(country, reader)}
{+capture-intent-endpoint}
app.post("/capture_payment_intent", async(req, res) => {
  const {span response capture-intent-endpoint}intent{/span} = await stripe.paymentIntents.capture(req.body.id);
  res.send(intent);
})
{/capture-intent-endpoint}

app.listen(4242, () => console.log('Node server listening on port 4242!'));
`;
};
